import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  InterruptBody,
  InterruptHostRef,
} from '../../../core/services/post-login-interrupt/post-login-interrupt.model';

@Component({
  selector: 'app-force-update-message',
  templateUrl: './force-update-message.component.html',
  styleUrls: ['./force-update-message.component.scss'],
  standalone: false,
})
export class ForceUpdateMessageComponent implements InterruptBody {
  /** An `@Input` (INC-328) so the frame can set it; call sites still assign it directly. */
  @Input() name: string;

  /**
   * INC-328 — set when this card is one page of the interrupt frame. Its outcome then
   * resolves THIS ITEM rather than tearing the frame down. Absent when the card is the
   * modal, which is still the single-interrupt path.
   */
  @Input() host?: InterruptHostRef;

  /**
   * Accepted for a uniform host contract and deliberately unused: this card is body-only
   * — no header, no footer — so there is no chrome of its own to suppress.
   */
  @Input() hostOwnsChrome?: boolean;

  constructor(private modal: NgbActiveModal) {}

  // "Verify now" — resolve. The caller keeps the investor on the profile-settings edit
  // form they were already routed to.
  verify() {
    if (this.host) {
      this.host.resolve();
      return;
    }
    this.modal.close();
  }

  // "Remind me later" — defer. The caller continues to the normal landing.
  remindLater() {
    if (this.host) {
      this.host.defer();
      return;
    }
    this.modal.dismiss();
  }
}
